import { compact, memoize } from 'lodash';

export const getTableHeaders = memoize(() =>
  compact([
    {
      label: t('in_person_training.events.event'),
      name: 'name',
      size: 'xl',
      clickable: true,
      loadingPlaceholder: {
        width: 55,
      },
    },
    {
      label: t('in_person_training.events.event_date'),
      name: 'start_time',
      size: 'l',
      clickable: true,
      sortType: 'numeric',
      classes: {
        hideBelowMD: true,
        center: true,
      },
      loadingPlaceholder: {
        width: 40,
      },
    },
    {
      label: t('in_person_training.events.location'),
      name: 'location',
      size: 'l',
      clickable: false,
      classes: {
        hideBelowMD: true,
        center: true,
      },
      loadingPlaceholder: {
        width: 40,
      },
    },
    {
      label: t('in_person_training.events.instructor'),
      name: 'instructor',
      size: 's',
      clickable: true,
      classes: {
        hideBelowMD: true,
        center: true,
      },
      loadingPlaceholder: {
        width: 40,
      },
    },
    {
      label: t('in_person_training.events.number_of_registered'),
      name: 'number_of_registered',
      size: 's',
      clickable: true,
      sortType: 'numeric',
      classes: {
        hideBelowMD: true,
        center: true,
      },
      loadingPlaceholder: {
        width: 40,
      },
    },
    {
      label: t('in_person_training.events.attended'),
      name: 'number_of_attendees',
      size: 's',
      clickable: true,
      sortType: 'numeric',
      classes: {
        hideBelowMD: true,
        center: true,
      },
      loadingPlaceholder: {
        width: 40,
      },
    },
    {
      label: t('in_person_training.events.date_updated'),
      name: 'date_updated',
      size: 'xl',
      clickable: true,
      sortType: 'numeric',
      classes: {
        hideBelowMD: true,
        center: true,
      },
      loadingPlaceholder: {
        width: 55,
      },
    },
  ]),
);
